var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentAwaitedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.5,
    height: 49.5,
    viewBox: "0 0 49.5 49.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#f9a409",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M12,6V21.6l10.4,5.2",
    transform: "translate(13.5 5.067)",
    fill: "none",
    stroke: "#f9a409",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAwaitedIcon);
export default __webpack_public_path__ + "static/media/payment-awaited-icon.00e86701a6ddf9f3eb2360baf39984e0.svg";
export { ForwardRef as ReactComponent };